import { render, staticRenderFns } from "./MedicalAdvice.vue?vue&type=template&id=957c7a7c&scoped=true"
import script from "./MedicalAdvice.vue?vue&type=script&lang=js"
export * from "./MedicalAdvice.vue?vue&type=script&lang=js"
import style0 from "./MedicalAdvice.vue?vue&type=style&index=0&id=957c7a7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957c7a7c",
  null
  
)

export default component.exports